/** The application's copyright line, slim enough for full-window screens. */
export default function AppFooter() {
  return (
    <footer className="shrink-0 border-t border-gray-200 bg-white py-2">
      <div className="mx-auto max-w-7xl px-4 text-center text-xs text-gray-500 sm:px-6 lg:px-8">
        <p>&copy; 2026 Palmerston North City Council &bull; ARA</p>
      </div>
    </footer>
  );
}
